import {
  product_image_01,
  product_image_02,
  product_image_03,
  product_image_04,
  product_image_05,
  product_image_06,
  product_image_07,
  product_image_08,
  product_image_09,
  product_image_10,
  product_image_11,
  product_image_12,
  product_image_13,
  product_image_14,
  product_image_15,
  product_image_16,
  product_image_01_a,
  product_image_01_b,
  product_image_01_c,
  product_image_02_a,
  product_image_02_b,
  product_image_03_a,
  product_image_03_b,
  product_image_03_c,
  product_image_04_a,
  product_image_04_b,
  product_image_04_c,
  product_image_05_a,
  product_image_05_b,
  product_image_05_c,
  product_image_06_a,
  product_image_06_b,
  product_image_06_c,
  product_image_07_a,
  product_image_07_b,
  product_image_07_c,
  product_image_08_a,
  product_image_08_b,
  product_image_08_c,
  product_image_09_a,
  product_image_09_b,
  product_image_09_c,
  product_image_10_a,
  product_image_10_b,
  product_image_10_c,
  product_image_11_a,
  product_image_11_b,
  product_image_11_c,
  product_image_12_a,
  product_image_12_b,
  product_image_12_c,
  product_image_13_a,
  product_image_13_b,
  product_image_13_c,
  product_image_14_a,
  product_image_14_b,
  product_image_14_c,
  product_image_15_a,
  product_image_15_b,
  product_image_15_c,
  product_image_16_a,
  product_image_16_b,
  product_image_16_c
} from 'assets/shop/productImages'

export const products = [
  {
    title: 'T-SHIRT THƯƠNG BẠN TRAI',
    price: '2800',
    image01: product_image_01,
    listImage: [product_image_01_a, product_image_01_b, product_image_01_c],
    categorySlug: 't-shirt',
    colors: 'white',
    slug: 't-shirt-thuong-ban-trai',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'T-SHIRT GAM WORLD 2023',
    price: '800',
    image01: product_image_02,
    listImage: [product_image_02_a, product_image_02_b],
    categorySlug: 't-shirt',
    colors: 'black',
    slug: 'gam-world-2023',
    size: ['s', 'm'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'T-SHIRT GRADIENT REGULAR',
    price: '1800',
    image01: product_image_03,
    listImage: [product_image_03_a, product_image_03_b, product_image_03_c],
    categorySlug: 't-shirt',
    colors: 'white',
    slug: 'gradient-regular',
    size: ['m'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'T-SHIRT INTERNET FRIENDS',
    price: '4800',
    image01: product_image_04,
    listImage: [product_image_04_a, product_image_04_b, product_image_04_c],
    categorySlug: 't-shirt',
    colors: 'black',
    slug: 'internet-friends',
    size: ['xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'RELAXED LOGO HOODIE - RED',
    price: '3900',
    image01: product_image_05,
    listImage: [product_image_05_a, product_image_05_b, product_image_05_c],
    categorySlug: 'hoodie',
    colors: 'red',
    slug: 'relaxed-logo-hoodie-red',
    size: ['xxl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'JACKET COLLAR SPRAY PAINT',
    price: '4900',
    image01: product_image_06,
    listImage: [product_image_06_a, product_image_06_b, product_image_06_c],
    categorySlug: 'jacket',
    colors: 'white',
    slug: 'jacket-collar-spray-paint',
    size: ['s', 'm', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'HOODIE LOGO RELAXED - GREY',
    price: '3900',
    image01: product_image_07,
    listImage: [product_image_07_a, product_image_07_b, product_image_07_c],
    categorySlug: 'hoodie',
    colors: 'white',
    slug: 'hoodie-logo-relaxed-grey',
    size: ['l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'T-SHIRT CHOPPER - BLACK',
    price: '2000',
    image01: product_image_08,
    listImage: [product_image_08_a, product_image_08_b, product_image_08_c],
    categorySlug: 't-shirt',
    colors: 'black',
    slug: 't-shirt-chopper-black',
    size: ['s', 'm', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'T-SHIRT THƯƠNG BẠN GÁI - BLACK',
    price: '1800',
    image01: product_image_09,
    listImage: [product_image_09_a, product_image_09_b, product_image_09_c],
    categorySlug: 't-shirt',
    colors: 'black',
    slug: 't-shirt-thuong-ban-gai',
    size: ['m'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'JACKET TRACK LOGO - BLACK',
    price: '4900',
    image01: product_image_10,
    listImage: [product_image_10_a, product_image_10_b, product_image_10_c],
    categorySlug: 'jacket',
    colors: 'black',
    slug: 'jacket-track-logo',
    size: ['l'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'JACKET WIND DICO - RED',
    price: '5900',
    image01: product_image_11,
    listImage: [product_image_11_a, product_image_11_b, product_image_11_c],
    categorySlug: 'jacket',
    colors: 'red',
    slug: 'jacket-wind-dico',
    size: ['s', 'm', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'T-SHIRT OP ACE - CREAM',
    price: '1800',
    image01: product_image_12,
    listImage: [product_image_12_a, product_image_12_b, product_image_12_c],
    categorySlug: 't-shirt',
    colors: 'white',
    slug: 't-shirt-op-ace',
    size: ['s', 'm', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'HAVE FUN CROP TOP',
    price: '800',
    image01: product_image_13,
    listImage: [product_image_13_a, product_image_13_b, product_image_13_c],
    categorySlug: 't-shirt',
    colors: 'black',
    slug: 't-shirt-have-fun-crop-top',
    size: ['s', 'm', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'LOVE CUBAN SHIRT',
    price: '2900',
    image01: product_image_14,
    listImage: [product_image_14_a, product_image_14_b, product_image_14_c],
    categorySlug: 'jacket',
    colors: 'white',
    slug: 'jacket-love-cuban-shirt',
    size: ['s', 'm', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'I THINK I DO',
    price: '2900',
    image01: product_image_15,
    listImage: [product_image_15_a, product_image_15_b, product_image_15_c],
    categorySlug: 't-shirt',
    colors: 'white',
    slug: 't-shirt-i-think-i-do',
    size: ['s', 'm', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'REGULAR TANK TOP',
    price: '200',
    image01: product_image_16,
    listImage: [product_image_16_a, product_image_16_b, product_image_16_c],
    categorySlug: 't-shirt',
    colors: 'white',
    slug: 't-shirt-regular-tank-top',
    size: ['s', 'm', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 17',
    price: '1400',
    image01: product_image_01,
    listImage: [product_image_01_a, product_image_01_b, product_image_01_c],
    categorySlug: 't-shirt',
    colors: 'white',
    slug: 'new-product-17',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 18',
    price: '1900',
    image01: product_image_02,
    listImage: [product_image_02_a, product_image_02_b],
    categorySlug: 't-shirt',
    colors: 'black',
    slug: 'new-product-18',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },

  {
    title: 'New Product 19',
    price: '1800',
    image01: product_image_03,
    listImage: [product_image_03_a, product_image_03_b, product_image_03_c],
    categorySlug: 't-shirt',
    colors: 'white',
    slug: 'new-product-19',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 20',
    price: '1800',
    image01: product_image_04,
    listImage: [product_image_04_a, product_image_04_b, product_image_04_c],
    categorySlug: 't-shirt',
    colors: 'black',
    slug: 'new-product-20',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 21',
    price: '1800',
    image01: product_image_05,
    listImage: [product_image_05_a, product_image_05_b, product_image_05_c],
    categorySlug: 'hoodie',
    colors: 'red',
    slug: 'new-product-21',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 22',
    price: '1800',
    image01: product_image_06,
    listImage: [product_image_06_a, product_image_06_b, product_image_06_c],
    categorySlug: 'jacket',
    colors: 'blue',
    slug: 'new-product-22',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 23',
    price: '1800',
    image01: product_image_07,
    listImage: [product_image_07_a, product_image_07_b, product_image_07_c],
    categorySlug: 'hoodie',
    colors: 'white',
    slug: 'new-product-23',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 24',
    price: '1800',
    image01: product_image_08,
    listImage: [product_image_08_a, product_image_08_b, product_image_08_c],
    categorySlug: 't-shirt',
    colors: 'black',
    slug: 'new-product-24',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 25',
    price: '1800',
    image01: product_image_09,
    listImage: [product_image_09_a, product_image_09_b, product_image_09_c],
    categorySlug: 't-shirt',
    colors: 'black',
    slug: 'new-product-25',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 26',
    price: '1800',
    image01: product_image_10,
    listImage: [product_image_10_a, product_image_10_b, product_image_10_c],
    categorySlug: 'jacket',
    colors: 'black',
    slug: 'new-product-26',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 27',
    price: '1800',
    image01: product_image_11,
    listImage: [product_image_11_a, product_image_11_b, product_image_11_c],
    categorySlug: 'jacket',
    colors: 'red',
    slug: 'new-product-27',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 28',
    price: '6800',
    image01: product_image_12,
    listImage: [product_image_12_a, product_image_12_b, product_image_12_c],
    categorySlug: 't-shirt',
    colors: 'white',
    slug: 'new-product-28',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 29',
    price: '1800',
    image01: product_image_13,
    listImage: [product_image_13_a, product_image_13_b, product_image_13_c],
    categorySlug: 't-shirt',
    colors: 'black',
    slug: 'new-product-29',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 30',
    price: '3800',
    image01: product_image_14,
    listImage: [product_image_14_a, product_image_14_b, product_image_14_c],
    categorySlug: 't-shirt',
    colors: 'white',
    slug: 'new-product-30',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 31',
    price: '1800',
    image01: product_image_15,
    listImage: [product_image_16_a, product_image_16_b, product_image_16_c],
    categorySlug: 't-shirt',
    colors: 'white',
    slug: 'new-product-31',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 32',
    price: '1800',
    image01: product_image_16,
    listImage: [product_image_16_a, product_image_16_b, product_image_16_c],
    categorySlug: 't-shirt',
    colors: 'white',
    slug: 'new-product-32',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 33',
    price: '1800',
    image01: product_image_01,
    listImage: [product_image_01_a, product_image_01_b, product_image_01_c],
    categorySlug: 't-shirt',
    colors: 'white',
    slug: 'new-product-33',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 34',
    price: '1800',
    image01: product_image_02,
    listImage: [product_image_02_a, product_image_02_b],
    categorySlug: 't-shirt',
    colors: 'black',
    slug: 'new-product-34',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 35',
    price: '1800',
    image01: product_image_03,
    listImage: [product_image_03_a, product_image_03_b, product_image_03_c],
    categorySlug: 't-shirt',
    colors: 'white',
    slug: 'new-product-35',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 36',
    price: '1800',
    image01: product_image_04,
    listImage: [product_image_04_a, product_image_04_b, product_image_04_c],
    categorySlug: 't-shirt',
    colors: 'black',
    slug: 'new-product-36',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 37',
    price: '1800',
    image01: product_image_05,
    listImage: [product_image_05_a, product_image_05_b, product_image_05_c],
    categorySlug: 'hoodie',
    colors: 'red',
    slug: 'new-product-37',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 38',
    price: '4500',
    image01: product_image_06,
    listImage: [product_image_06_a, product_image_06_b, product_image_06_c],
    categorySlug: 'jacket',
    colors: 'blue',
    slug: 'new-product-38',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 39',
    price: '1800',
    image01: product_image_07,
    listImage: [product_image_07_a, product_image_07_b, product_image_07_c],
    categorySlug: 'hoodie',
    colors: 'white',
    slug: 'new-product-39',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 40',
    price: '2800',
    image01: product_image_08,
    listImage: [product_image_08_a, product_image_08_b, product_image_08_c],
    categorySlug: 't-shirt',
    colors: 'black',
    slug: 'new-product-40',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 41',
    price: '1800',
    image01: product_image_09,
    listImage: [product_image_09_a, product_image_09_b, product_image_09_c],
    categorySlug: 't-shirt',
    colors: 'black',
    slug: 'new-product-41',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 42',
    price: '3800',
    image01: product_image_10,
    listImage: [product_image_10_a, product_image_10_b, product_image_10_c],
    categorySlug: 'jacket',
    colors: 'black',
    slug: 'new-product-42',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 43',
    price: '1800',
    image01: product_image_11,
    listImage: [product_image_11_a, product_image_11_b, product_image_11_c],
    categorySlug: 'jacket',
    colors: 'red',
    slug: 'new-product-43',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 44',
    price: '700',
    image01: product_image_12,
    listImage: [product_image_12_a, product_image_12_b, product_image_12_c],
    categorySlug: 't-shirt',
    colors: 'white',
    slug: 'new-product-44',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 45',
    price: '1800',
    image01: product_image_13,
    listImage: [product_image_13_a, product_image_13_b, product_image_13_c],
    categorySlug: 't-shirt',
    colors: 'black',
    slug: 'new-product-45',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 46',
    price: '6000',
    image01: product_image_14,
    listImage: [product_image_14_a, product_image_14_b, product_image_14_c],
    categorySlug: 't-shirt',
    colors: 'white',
    slug: 'new-product-46',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 47',
    price: '1800',
    image01: product_image_15,
    listImage: [product_image_15_a, product_image_15_b, product_image_15_c],
    categorySlug: 't-shirt',
    colors: 'white',
    slug: 'new-product-47',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 48',
    price: '1900',
    image01: product_image_16,
    listImage: [product_image_16_a, product_image_16_b, product_image_16_c],
    categorySlug: 't-shirt',
    colors: 'white',
    slug: 'new-product-48',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 49',
    price: '2700',
    image01: product_image_01,
    listImage: [product_image_01_a, product_image_01_b, product_image_01_c],
    categorySlug: 't-shirt',
    colors: 'white',
    slug: 'new-product-49',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 50',
    price: '1800',
    image01: product_image_02,
    listImage: [product_image_02_a, product_image_02_b],
    categorySlug: 't-shirt',
    colors: 'black',
    slug: 'new-product-50',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 51',
    price: '1800',
    image01: product_image_03,
    listImage: [product_image_03_a, product_image_03_b, product_image_03_c],
    categorySlug: 't-shirt',
    colors: 'white',
    slug: 'new-product-51',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 52',
    price: '1800',
    image01: product_image_04,
    listImage: [product_image_04_a, product_image_04_b, product_image_04_c],
    categorySlug: 't-shirt',
    colors: 'black',
    slug: 'new-product-52',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 53',
    price: '3800',
    image01: product_image_05,
    listImage: [product_image_05_a, product_image_05_b, product_image_05_c],
    categorySlug: 'hoodie',
    colors: 'red',
    slug: 'new-product-53',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 54',
    price: '1800',
    image01: product_image_06,
    listImage: [product_image_06_a, product_image_06_b, product_image_06_c],
    categorySlug: 'jacket',
    colors: 'blue',
    slug: 'new-product-54',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 55',
    price: '1800',
    image01: product_image_07,
    listImage: [product_image_07_a, product_image_07_b, product_image_07_c],
    categorySlug: 'hoodie',
    colors: 'white',
    slug: 'new-product-55',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 56',
    price: '4500',
    image01: product_image_08,
    listImage: [product_image_08_a, product_image_08_b, product_image_08_c],
    categorySlug: 't-shirt',
    colors: 'black',
    slug: 'new-product-56',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 57',
    price: '1800',
    image01: product_image_09,
    listImage: [product_image_09_a, product_image_09_b, product_image_09_c],
    categorySlug: 't-shirt',
    colors: 'black',
    slug: 'new-product-57',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 58',
    price: '1800',
    image01: product_image_10,
    listImage: [product_image_10_a, product_image_10_b, product_image_10_c],
    categorySlug: 'jacket',
    colors: 'black',
    slug: 'new-product-58',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 59',
    price: '200',
    image01: product_image_11,
    listImage: [product_image_11_a, product_image_11_b, product_image_11_c],
    categorySlug: 'jacket',
    colors: 'red',
    slug: 'new-product-59',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  },
  {
    title: 'New Product 60',
    price: '5800',
    image01: product_image_12,
    listImage: [product_image_12_a, product_image_12_b, product_image_12_c],
    categorySlug: 't-shirt',
    colors: 'white',
    slug: 'new-product-60',
    size: ['s', 'm', 'l', 'xl'],
    description: {
      title: 'Dreamer T-Shirt',
      quality: '100% 4-way stretch cotton',
      size: ' Medium, Large, X-Large',
      color: 'Black, White, Blue'
    }
  }
]
